<script lang="ts">
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Spinner from '$lib/components/atoms/spinner/Spinner.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		disabled?: boolean;
		isLoading?: boolean;
		onclick?: () => void;
	}

	const { disabled = false, isLoading = false, onclick }: Props = $props();
</script>

<div class="flex flex-col gap-2">
	<div
		class={['grid-cols-[auto_minmax(0,_1fr)] items-center w-59 bg-coloredneutral-weakest p-2 text-sm gap-1 rd-1', disabled ? 'hidden' : 'grid']}
	>
		<Icon icon="info" class="size-4" />
		<div>{m.register_car__fill_to_save()}</div>
	</div>

	{#if isLoading}
		<Spinner />
	{:else}
		<Button text={m.action__save()} class="w-fit" {disabled} {onclick} />
	{/if}
</div>
